import type { LucideIcon } from 'lucide-react';
import { File as FileIcon, Image as ImageIcon, Presentation as PresentationIcon, Table2 } from 'lucide-react';

const IMAGE_EXTS = new Set(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg']);
const TABLE_EXTS = new Set(['xls', 'xlsx', 'csv', 'numbers']);
const PRESENTATION_EXTS = new Set(['ppt', 'pptx', 'key']);

export function getFileIcon(fileName: string): LucideIcon {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
  if (IMAGE_EXTS.has(ext)) return ImageIcon;
  if (TABLE_EXTS.has(ext)) return Table2;
  if (PRESENTATION_EXTS.has(ext)) return PresentationIcon;
  return FileIcon;
}
